import UserStatus from '../enums/UserStatus';

export default class User {
  constructor(data) {
    this.id = data?.id;
    this.status = data?.status ? UserStatus.of(data.status) : null;
    this.name = data?.name;
    this.email = data?.email;
    this.password = data?.password;
    this.registrationToken = data?.registrationToken;
    this.rememberToken = data?.rememberToken;
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
    this.permissions = data?.permissions || [];
  }
}

